import React, { useState } from "react";
import Slider from "react-slick";

export default function ReviewCardMobileSlider({ children }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    speed: 2000,
    autoplaySpeed: 4000,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    customPaging: (i) => (
      <div
        className={`w-[10px] h-[10px] rounded-full mx-2 ${
          i === currentSlide ? "bg-[#1DA1F2]" : "bg-[#D9D9D9]"
        }`}
      ></div>
    ),
    appendDots: (dots) => (
      <div style={{ position: "relative" }}>
        <ul
          style={{
            margin: "0px",
            padding: "0px",
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            bottom: "-20px",
            width: "100%",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
  };
  return <Slider {...settings}>{children}</Slider>;
}
